var _style, _g, _g2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSurveillance = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 55 55",
    style: {
      enableBackground: "new 0 0 55 55"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.7;}\n\t.st1{fill:#FFD600;}\n\t.st2{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 27.5,
    cy: 27.5,
    r: 26.3
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M27.5,3.2c13.4,0,24.3,10.9,24.3,24.3S40.9,51.8,27.5,51.8S3.2,40.9,3.2,27.5S14.1,3.2,27.5,3.2 M27.5,1.2 C13,1.2,1.2,13,1.2,27.5S13,53.8,27.5,53.8S53.8,42,53.8,27.5S42,1.2,27.5,1.2L27.5,1.2z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M27.6,17.4c-9.9,0-15.8,10.1-15.8,10.1s5.9,10.1,15.8,10.1c9.7,0,15.6-10.1,15.6-10.1S37.3,17.4,27.6,17.4z  M27.5,20.5c3.8,0,6.9,3.1,6.9,7s-3.1,7-6.9,7s-6.9-3.1-6.9-7S23.7,20.5,27.5,20.5z M27.5,23.5c-2.2,0-3.9,1.8-3.9,4s1.8,4,3.9,4 s3.9-1.8,3.9-4c0-0.6-0.1-1.1-0.3-1.6c-0.3,0.4-0.7,0.6-1.2,0.6c-0.8,0-1.5-0.7-1.5-1.5c0-0.5,0.2-0.9,0.6-1.2 C28.6,23.6,28.1,23.5,27.5,23.5z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSurveillance);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/surveillance.540d2f6e903ee20bc5591e939156f654.svg";